// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__26pra","head":"Table_head__2Uq_o","col":"Table_col__2BV3Y"};